import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { PowerPlayerBolt } from './powerPlayerBolt';
/**
 * Intended to be used inline with text.
 */
export const PowerPlayerBoltInlineIcon = ({ powerPlayerBoltColor, size = 'small', title, marginLeftPx = 10 }) => (_jsx("span", { css: css `
      margin: 0 0 0 ${marginLeftPx}px;
      line-height: 1em;
    `, title: title, children: _jsx(PowerPlayerBolt, { color: powerPlayerBoltColor, size: size }) }));
